import _ from 'lodash'
import sumEnabledRowsInCategory from './helpers/sumEnabledRowsInCategory'

export default (form, baseName) => sumEnabledRowsInCategory(form, _.join(_.compact([baseName, 'items']), '.'))
